import getConfig from 'next/config'
import { useRouter } from 'next/router'
import { InferGetServerSidePropsType } from 'next'
import { BreadcrumbJsonLd } from 'next-seo'

import { getServerSideProps } from '@/pages/insights'

import {
  ErrorPage,
  DocumentHead as Head,
  Category,
} from '@/components'

export { getServerSideProps }

const { webDomain } = getConfig().publicRuntimeConfig

const TopicPage: React.FC<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({
  data,
  languageData,
  status,
  currentDomain,
  latestArticles,
  isRedis,
  locale,
  lang,
  latestArticlesLength,
}) => {
  // eslint-disable-next-line no-console
  if (isRedis) console.log('v.2.1')

  if (status) return <ErrorPage code={status} domain={currentDomain} />
  if (!data) return <ErrorPage code="404" domain={currentDomain} />

  const { query } = useRouter()
  const topicSlug = query?.slug?.[0] || ''

  return (
    <>
      <Head data={data.seo} languageData={languageData} />
      <BreadcrumbJsonLd itemListElements={[
        {
          position: 1,
          name: 'Homepage',
          item: `https://${webDomain}/`,
        },
        {
          position: 2,
          name: 'Insights',
          item: `https://${webDomain}/insights`,
        },
        {
          position: 3,
          name: topicSlug,
          item: `https://${webDomain}/insights/topic/${topicSlug}`,
        },
      ]} />
      <Category
        {...data}
        articles={latestArticles} 
        locale={locale}
        lang={lang}
        latestArticlesLength={latestArticlesLength}
      />
    </>
  )
}

export default TopicPage
